import { Provider } from "react-redux";
import ShoppingCart from "./components/ShoppingCart";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div>
        <ShoppingCart />
      </div>
    </Provider>
  );
}

export default App;
